import {Context} from 'react'
import {RuntimeContext} from '../../../../../commons/components/runtime-context/runtime-context'
import {DetailsPageAppProps} from '../app/interfaces'

export const DetailsPageRuntimeContext: Context<DetailsPageAppProps> = RuntimeContext
